import React from 'react';
import AgentConversation from '../agents/shared/AgentConversation';
import { schemaMappingAgentSpec } from './spec';

const SchemaMappingAgentConversation: React.FC = () => (
  <AgentConversation spec={schemaMappingAgentSpec} />
);

export default SchemaMappingAgentConversation;
